export default "__VITE_ASSET__De31Y5f5__"